// If the getOracleColor function executes in a server-side render, it will need
// a fallback. I'm unsure how to get this from the SCSS file, so it is
// duplicated here. Only include keys that are actually used, because it is more
// and weird babysitting to do.
const fallbacks = {
  'oracle-p20': '#E8DCF2',
  'oracle-p60': '#71428B',
  'oracle-n60': '#6f7788',
}

export type FallbackKey = keyof typeof fallbacks

// Get CSS variable values at runtime, with fallbacks
export const getOracleColor = (varName: string, fallback: FallbackKey): string => {
  if (typeof window !== 'undefined') {
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName)
    return value.trim() || fallbacks[fallback]
  }
  return fallbacks[fallback]
}
